import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "@/lib/currencyFormatter";

interface WeeklyRevenueData {
  name: string;
  revenue: number;
}

interface WeeklyRevenueChartProps {
  data: WeeklyRevenueData[];
  isLoading: boolean;
}

export const WeeklyRevenueChart = ({
  data,
  isLoading,
}: WeeklyRevenueChartProps) => {
  const { t } = useTranslation();

  const formatTooltipValue = (value: number) => {
    return formatCurrency(value);
  };

  return (
    <Card className="col-span-2 animate-fade-in animate-delay-300">
      <CardHeader>
        <CardTitle>{t("weeklyRevenue")}</CardTitle>
        <CardDescription>{t("weeklyRevenueDescription")}</CardDescription>
      </CardHeader>
      <CardContent className="h-80">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <p>{t("loading")}</p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={data}
              margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
            >
              <defs>
                <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                  <stop
                    offset="5%"
                    stopColor="hsl(var(--primary))"
                    stopOpacity={0.8}
                  />
                  <stop
                    offset="95%"
                    stopColor="hsl(var(--primary))"
                    stopOpacity={0}
                  />
                </linearGradient>
              </defs>
              <XAxis dataKey="name" />
              <YAxis tickFormatter={formatTooltipValue} />
              <CartesianGrid strokeDasharray="3 3" />
              <Tooltip formatter={formatTooltipValue} />
              <Area
                type="monotone"
                dataKey="revenue"
                stroke="hsl(var(--primary))"
                fillOpacity={1}
                fill="url(#colorRevenue)"
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};
